import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './SceneNav.scss';
import { ArrowLeft16, DotMark16 } from '@carbon/icons-react';
import data from '../../locales/en.json';
import { _setHome, _setCurrentScene } from '../../store/actionCreators';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { ScaleText } from '../../utils';

const SceneNav = () => {
  const home = useSelector((state) => state.home);
  const currentScene = useSelector((state) => state.currentScene);
  const transitioning = useSelector((state) => state.transitioning);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  // eslint-disable-next-line no-unused-vars
  const scaledText_home = ScaleText(
    data.Content.scene.map(() => `Content.home.title`),
    { xlg: 24, lg: 18 },
    '1.3em',
  );
  const scaledText_scene = ScaleText(
    data.Content.scene.map((_, i) => `Content.scene.${i}.title`),
    { xlg: 24, lg: 18 },
    '1.3em',
  );

  useEffect(() => {
    if (home) {
      setShow(false);
    } else {
      if (!transitioning) setShow(true);
    }
    // eslint-disable-next-line
  }, [transitioning]);

  const setHome = (bool) => {
    dispatch(_setHome(bool));
  };
  const setCurrentScene = (num) => {
    dispatch(_setCurrentScene(num));
  };

  const handleClickHome = () => {
    if (!transitioning) {
      setHome(true);
      setCurrentScene(null);
    }
  };

  const handleClickScene = (i) => {
    if (!transitioning && i !== currentScene) {
      setHome(false);
      setCurrentScene(i);
    }
  };

  return (
    <CSSTransition
      in={show}
      timeout={{ enter: 110 + 300, exit: 400 + 150 }}
      classNames="scenenav-display"
      unmountOnExit>
      <div className="scenenav-container slow-01">
        <div className="bx--grid">
          <div className="bx--row">
            <div className="column bx--col-sm-0 bx--col-md-0 bx--col-lg-4 bx--col-xlg-4 bx--col-max-4">
              <div className="scenenav">
                {/* home button */}
                <button
                  className="home-btn expressive-heading-03 white fast-02-staggered"
                  onClick={handleClickHome}>
                  <span>
                    <ArrowLeft16 />
                  </span>
                  <FormattedMessage
                    id="Content.home.title"
                    defaultMessage={data.Content.home.title}>
                    {(txt) => (
                      <div className="text" style={scaledText_home}>
                        {txt}
                      </div>
                    )}
                  </FormattedMessage>
                </button>

                {/* scene button */}
                {data.Content.scene.map((scene, i) => (
                  <button
                    className={`scene-btn expressive-heading-03 fast-02-staggered white-hover ${
                      i === currentScene ? 'white btn-on' : 'gray-50'
                    }`}
                    style={{ transitionDelay: `${(i + 1) * 50}ms` }}
                    onClick={() => handleClickScene(i)}
                    key={i}>
                    <span>
                      <DotMark16 />
                    </span>
                    <FormattedMessage
                      id={`Content.scene.${i}.title`}
                      defaultMessage={scene.title}>
                      {(txt) => (
                        <div className="text" style={scaledText_scene}>
                          {txt}
                        </div>
                      )}
                    </FormattedMessage>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default SceneNav;
